module.exports = __webpack_public_path__ + "img/solution1.de1d9904.png";